module.exports = __webpack_public_path__ + "img/saintsimon.35f29b73.jpg";